export default __webpack_public_path__ + "static/emenu-presentation-709479ed909687bdf8e26b6c80196a68.png";